import classNames from "classnames";
import React, { useState, useEffect } from "react";
import AuthLayout from "../../../layouts/AuthLayout";
import PersonalInformation from "./components/PersonalInformation";
import CommunicationInformation from "./components/CommunicationInformation";
import WorkAndStudyInformation from "./components/WorkAndStudyInformation";
import {
  getBayiFirms,
  getBayiBranches,
  updateBayiProfile,
  logout,
  ConfirmOTPBayi,
} from "../../../services/authService";
import Modal from "../../../components/shared/Modal";
import LoadingModal from "../../../components/shared/LoadingModal";
import { useSelector, useDispatch } from "react-redux";
import { SET_USER } from "../../../store/app/appSlice";
import SmsVerification from "./components/SmsVerification";

const CLARIFICATION_TEXT_URL =
  "https://kale.my.salesforce.com/sfc/p/0Y000002Hxdp/a/P5000006JWf7/lNPECYOUPCQfFAInvW1GqHD6W4HpcCFYFyIWxiLSyj0";

export default function UpdateProfile() {
  const [userData, setUserData] = useState({
    hide_profile: true,
    // isFriendsCanSeeAlbums: false,
    kkEmailPermission: false,
    kkSMSPermission: false,
    kkCallPermission: false,
    username: "",
    Email: "",
    // kkKvkkConfirm: false,
    ksEmailPermission: false,
    ksSMSPermission: false,
    ksCallPermission: false,
    // ksKvkkConfirm: false,
  });
  const [activeTab, setActiveTab] = useState(1);
  const [kkIysPermission, setKkIysPermission] = useState(false);
  const [ksIysPermission, setKsIysPermission] = useState(false);
  const [errors, setErrors] = useState({
    emailEmpty: false,
    isEmail: true,
    usernameEmpty: false,
    usernameLengthCorrect: true,
    placierEmpty: false,
    titleEmpty: false,
    educationEmpty: false,
    firmEmpty: false,
    branchEmpty: false,
    cityEmpty: false,
    regionEmpty: false,
    zipEmpty: false,
    addressEmpty: false,
  });
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [firms, setFirms] = useState(null);
  const [branches, setBranches] = useState(null);
  const [apiError, setApiError] = useState(null);
  const [hiddenApproveProfileImage, setHiddenApproveProfileImage] =
    useState(false);
  const [temporaryProfileImage, setTemporaryProfileImage] = useState(null);
  const user = useSelector((state) => state.app.user);
  const pointData = useSelector((state) => state.app.pointData);
  const dispatch = useDispatch();

  //For the sms verification
  const [showSmsModal, setShowSmsModal] = useState(false);
  const [duration, setDuration] = useState(null);
  const [jwt, setJwt] = useState(null);
  const [code, setCode] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [errorModal, setErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      if (userData?.siteId) {
        const firms = await getBayiFirms(userData?.siteId);
        setFirms(firms);
        let branches;
        if (userData.firm) {
          branches = await getBayiBranches(userData?.firm);
        }
        setBranches(branches);
      }
    })();
    //eslint-disable-next-line
  }, [userData?.firm, userData?.siteId]);

  useEffect(() => {
    (async () => {
      if (isConfirmed) {
        await update();
        await logout();
        window.location.href = "/";
      }
    })();
    //eslint-disable-next-line
  }, [isConfirmed]);

  useEffect(() => {
    if (userData?.siteId === "tali") {
      setUserData((prev) => ({
        ...prev,
        placier: "",
        ksEmailPermission: false,
        ksSMSPermission: false,
        ksCallPermission: false,
        ksKvkkPermission: true,
      }));
    }
  }, [userData?.siteId]);

  useEffect(() => {
    (async () => {
      if (user) {
        const {
          Email,
          email,
          username,
          Billing_City__c,
          Billing_Region__c,
          Billing_City__r,
          Billing_Region__r,
          BillingStreet,
          City__r,
          zipCode,
          address,
          placier,
          Title_of_Person__c,
          Class__c,
          Education_Status__c,
          firm,
          branch,
          // isFriendsCanSeeAlbums,
          hide_profile,
          kkEmailPermission,
          kkSMSPermission,
          kkCallPermission,
          ksEmailPermission,
          ksSMSPermission,
          ksCallPermission,
          The_Kale_Company_Work_With__c,
          profile_image,
          Name,
          birthdate,
          siteId,
        } = user;

        setUserData({
          Email,
          email,
          username,
          Billing_City__c,
          Billing_Region__c,
          Billing_City__r,
          Billing_Region__r,
          BillingStreet,
          City__r,
          zipCode,
          address,
          placier,
          Title_of_Person__c,
          Class__c,
          Education_Status__c,
          firm,
          branch,
          // isFriendsCanSeeAlbums,
          // OnlyFriendsCanSee,
          hide_profile,
          kkEmailPermission,
          kkSMSPermission,
          kkCallPermission,
          ksEmailPermission,
          ksSMSPermission,
          ksCallPermission,
          The_Kale_Company_Work_With__c,
          profile_image,
          Name,
          birthdate,
          siteId,
        });
        setKkIysPermission(!!(kkEmailPermission || kkSMSPermission || kkCallPermission));
        setKsIysPermission(!!(ksEmailPermission || ksSMSPermission || ksCallPermission));
      }
    })();
  }, [user]);

  const updateProfile = async (e) => {
    e.preventDefault();
    if (
      errors.emailEmpty ||
      !errors.isEmail ||
      errors.usernameEmpty ||
      !errors.usernameLengthCorrect ||
      errors.placierEmpty ||
      errors.titleEmpty ||
      errors.educationEmpty ||
      errors.firmEmpty ||
      // errors.branchEmpty ||
      errors.cityEmpty ||
      errors.regionEmpty ||
      errors.zipEmpty ||
      errors.addressEmpty
    ) {
      return;
    } else {
      if (user?.branch !== userData?.branch || user?.firm !== userData?.firm) {
        setOpenWarningModal(true);
      } else {
        await update();
        setHiddenApproveProfileImage(true);
      }
    }
  };

  const update = async () => {
    try {
      setLoading(true);

      const nextUserData = {
        ...userData,
        kkEmailPermission: kkIysPermission ? !!userData.kkEmailPermission : false,
        kkSMSPermission: kkIysPermission ? !!userData.kkSMSPermission : false,
        kkCallPermission: kkIysPermission ? !!userData.kkCallPermission : false,
        ksEmailPermission: ksIysPermission ? !!userData.ksEmailPermission : false,
        ksSMSPermission: ksIysPermission ? !!userData.ksSMSPermission : false,
        ksCallPermission: ksIysPermission ? !!userData.ksCallPermission : false,
      };

      const updatedData = {};
      for (const key in nextUserData) {
        if (nextUserData[key] !== user[key]) {
          updatedData[key] = nextUserData[key];
        }
      }

      // Phone (username) change goes through the new IYS OTP flow.
      if ("username" in updatedData) {
        updatedData.iysFlow = true;
      }

      let updateResponse = await updateBayiProfile(updatedData);
      if (updateResponse.OTPResponse) {
        setLoading(false);
        setJwt(updateResponse.OTPResponse.jwt);
        setDuration(
          Math.round(
            (Date.parse(`${updateResponse.OTPResponse.expiresAt}`) -
              Date.now()) /
            1000
          )
        );
        setShowSmsModal(true);
        return;
      } else {
        setLoading(false);
        setOpenSuccessModal(true);
        const {
          email,
          username,
          Billing_City__c,
          Billing_Region__c,
          Billing_City__r,
          Billing_Region__r,
          BillingStreet,
          City__r,
          zipCode,
          address,
          placier,
          Title_of_Person__c,
          Class__c,
          Education_Status__c,
          firm,
          branch,
          // isFriendsCanSeeAlbums,
          // OnlyFriendsCanSee,
          hide_profile,
          kkEmailPermission,
          kkSMSPermission,
          kkCallPermission,
          ksEmailPermission,
          ksSMSPermission,
          ksCallPermission,
          The_Kale_Company_Work_With__c,
          profile_image,
          Name,
        } = userData;
        dispatch(
          SET_USER({
            ...user,
            email,
            username,
            Billing_City__c,
            Billing_Region__c,
            Billing_City__r,
            Billing_Region__r,
            BillingStreet,
            City__r,
            zipCode,
            address,
            placier,
            Title_of_Person__c,
            Class__c,
            Education_Status__c,
            firm,
            branch,
            // isFriendsCanSeeAlbums,
            // OnlyFriendsCanSee,
            hide_profile,
            kkEmailPermission,
            kkSMSPermission,
            kkCallPermission,
            ksEmailPermission,
            ksSMSPermission,
            ksCallPermission,
            The_Kale_Company_Work_With__c,
            profile_image: profile_image,
            Name,
          })
        );
      }
    } catch (error) {
      setLoading(false);
      setApiError(error.message);
      setOpenErrorModal(true);
    }
  };

  const getFirmName = (firmId) => {
    const currentFirm = firms?.find((firm) => firm.Id === firmId);
    return currentFirm?.Name;
  };

  const getBranchType = (branchId) => {
    if (userData?.branch) {
      const currentBranch = branches?.find((branch) => branch.Id === branchId);
      return currentBranch?.Type;
    }
  };

  const activeTabMarkup = () => {
    switch (activeTab) {
      case 1:
        return (
          <CommunicationInformation
            userData={userData}
            setUserData={(info) => setUserData(info)}
            errors={errors}
            setErrors={(error) => setErrors(error)}
            user={user}
          />
        );
      case 2:
        return (
          <WorkAndStudyInformation
            userData={userData}
            setUserData={(info) => setUserData(info)}
            errors={errors}
            setErrors={(error) => setErrors(error)}
            firms={firms}
            getFirmName={getFirmName}
            branches={branches}
            getBranchType={getBranchType}
          />
        );
      case 3:
        return (
          <PersonalInformation
            userData={userData}
            setUserData={(info) => setUserData(info)}
            errors={errors}
            setErrors={(error) => setErrors(error)}
            user={user}
          />
        );
      default:
        return;
    }
  };

  const handleAfterSubmit = () => {
    setIsLoading(true);
    ConfirmOTPBayi(jwt, code)
      .then((result) => {
        if (!result.error) {
          const {
            email,
            username,
            Billing_City__c,
            Billing_Region__c,
            Billing_City__r,
            Billing_Region__r,
            BillingStreet,
            City__r,
            zipCode,
            address,
            placier,
            Title_of_Person__c,
            Class__c,
            Education_Status__c,
            firm,
            branch,
            // isFriendsCanSeeAlbums,
            // OnlyFriendsCanSee,
            hide_profile,
            kkEmailPermission,
            kkSMSPermission,
            kkCallPermission,
            ksEmailPermission,
            ksSMSPermission,
            ksCallPermission,
            The_Kale_Company_Work_With__c,
            profile_image,
            Name,
          } = userData;
          dispatch(
            SET_USER({
              ...user,
              email,
              username,
              Billing_City__c,
              Billing_Region__c,
              Billing_City__r,
              Billing_Region__r,
              BillingStreet,
              City__r,
              zipCode,
              address,
              placier,
              Title_of_Person__c,
              Class__c,
              Education_Status__c,
              firm,
              branch,
              // isFriendsCanSeeAlbums,
              // OnlyFriendsCanSee,
              hide_profile,
              kkEmailPermission,
              kkSMSPermission,
              kkCallPermission,
              ksEmailPermission,
              ksSMSPermission,
              ksCallPermission,
              The_Kale_Company_Work_With__c,
              profile_image: profile_image,
              Name,
              mobile_verified: true,
            })
          );
          setShowSmsModal(false);
          setSuccessMsg(result);
          setShowSuccessModal(true);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        setErrMsg(e.message);
        setIsLoading(false);
      });
  };
  return (
    <AuthLayout>
      <Modal
        shouldShow={openSuccessModal}
        type="success"
        msg="Profil başarıyla güncellendi."
        updateModalState={(state) => setOpenSuccessModal(state)}
      />
      <Modal
        shouldShow={openErrorModal}
        type="error"
        msg={apiError ? apiError : "Profil güncellenirken hata oluştu."}
        updateModalState={(state) => setOpenErrorModal(state)}
      />
      <Modal
        shouldShow={openWarningModal}
        type="warning"
        msg="Bu bilgileri değiştirirseniz oturumunuz sonlandırılacak ve hesabınız onay bekliyor durumuna getirilecektir."
        updateModalState={(state) => setOpenWarningModal(state)}
        setIsConfirmed={(state) => setIsConfirmed(state)}
      />
      <SmsVerification
        isLoading={isLoading}
        code={code}
        setCode={(state) => setCode(state)}
        handleAfterSubmit={handleAfterSubmit}
        jwt={jwt}
        setJwt={(state) => setJwt(state)}
        setDuration={(state) => setDuration(state)}
        duration={duration}
        shouldShow={showSmsModal}
        updateModalState={(state) => setShowSmsModal(state)}
        successMsg={successMsg}
        setSuccessMsg={(state) => setSuccessMsg(state)}
        errMsg={errMsg}
        setErrMsg={(state) => setErrMsg(state)}
        closeOnOutsideClick={false}
      />
      {showSuccessModal && (
        <Modal
          // handleAfterClose={handleSuccess}
          type="success"
          msg={successMsg}
          updateModalState={(state) => setShowSuccessModal(state)}
          shouldShow={showSuccessModal}
        />
      )}
      {errorModal && (
        <Modal
          // handleAfterClose={handleSuccess}
          type="error"
          msg={errMsg || "Bir hata oluştu"}
          updateModalState={(state) => setErrorModal(state)}
          shouldShow={errorModal}
        />
      )}
      {loading && <LoadingModal />}
      <div id="content">
        <div className="px-4 py-5 bg-background-teal lg:py-16 lg:px-0">
          <main className="mx-auto max-w-7xl md:px-4 lg:px-1">
            <div className="flex flex-col justify-between lg:flex-row lg:items-center">
              <h1 className="mb-4 text-md lg:text-xxl text-primary-black font-lg lg:mb-0">
                Bilgileri Güncelleme
              </h1>
            </div>
          </main>
        </div>
        <div className="max-w-4xl px-4 mx-auto my-12 lg:my-16 lg:px-0">
          <form onSubmit={(e) => updateProfile(e)}>
            <div className="max-w-md mx-auto mb-16">
              <div className="flex justify-center">
                <div className="relative flex items-center justify-center w-36 h-36 rounded-full bg-secondary-titles">
                  {user?.profile_image?.url ? (
                    <img
                      src={
                        user?.profile_photo_approved &&
                          !hiddenApproveProfileImage
                          ? temporaryProfileImage || user?.profile_image?.url
                          : "/images/image-approve.png"
                      }
                      alt="profile-img"
                      className="w-full h-full object-center object-cover rounded-full"
                    />
                  ) : (
                    <>
                      {temporaryProfileImage ? (
                        <img
                          src={
                            temporaryProfileImage || user?.profile_image?.url
                          }
                          alt="profile-img"
                          className="w-full h-full object-center object-cover rounded-full"
                        />
                      ) : (
                        <>
                          <span className="sr-only">User</span>
                          <svg role="img" className="w-20 h-20 text-white">
                            <use xlinkHref="/assets/img/necromancers.svg#user" />
                          </svg>
                        </>
                      )}
                    </>
                  )}

                  {user?.profile_photo_approved &&
                    !hiddenApproveProfileImage && (
                      <button className="absolute flex items-center justify-center w-12 h-12 overflow-hidden border-2 rounded-full bg-secondary-primary border-primary-white -bottom-6">
                        <input
                          type="file"
                          className="absolute h-full opacity-0 cursor-pointer"
                          onChange={(e) => {
                            setUserData({
                              ...userData,
                              profile_image: e.target.files[0],
                            });
                            setTemporaryProfileImage(
                              URL.createObjectURL(e.target.files[0])
                            );
                          }}
                        />
                        <span className="sr-only">Photo Add</span>
                        <svg
                          role="img"
                          className="w-6 h-6 text-white"
                          fill="none"
                        >
                          <use xlinkHref="/assets/img/necromancers.svg#photo-add" />
                        </svg>
                      </button>
                    )}
                </div>
                <div className="ml-6">
                  {!user ? (
                    <div style={{ width: 244, height: 144 }}></div>
                  ) : (
                    <>
                      <p className="mb-2 text-sm font-bold">{user?.Name}</p>
                      <p className="mb-2 text-base text-secondary-primary">
                        {getFirmName(user?.firm)}
                      </p>
                      <p>
                        {user?.TypeKS__c === "true" &&
                          user?.TypeKK__c === "false" &&
                          "KS"}
                        {user?.TypeKK__c === "true" &&
                          user?.TypeKS__c === "false" &&
                          "KK"}
                        {user?.TypeKS__c === "true" &&
                          user?.TypeKK__c === "true" &&
                          "KS - KK"}
                      </p>
                      <p className="mb-2 text-sm font-bold">
                        {pointData?.total_point
                          ?.toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                      </p>
                      <p className="text-base text-secondary-primary">
                        Kale Puan
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="space-y-12">
              <div className="text-center">
                <div className="relative z-0 inline-flex bg-secondary-secondary-bg mx-auto p-0.5">
                  <button
                    type="button"
                    onClick={() => setActiveTab(1)}
                    className={classNames(
                      activeTab === 1
                        ? "inline-block !bg-primary-red !text-white active"
                        : "inline-block !text-primary-black !bg-transparent",
                      "px-4 tab-btn text-primary-black hover:text-white lg:w-auto"
                    )}
                  >
                    İletişim Bilgileri
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab(2)}
                    className={classNames(
                      activeTab === 2
                        ? "inline-block !bg-primary-red !text-white active"
                        : "inline-block !text-primary-black !bg-transparent",
                      "px-4 break-normal tab-btn text-primary-black hover:text-white lg:w-auto"
                    )}
                  >
                    {" "}
                    İş-Eğitim Bilgileri{" "}
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab(3)}
                    className={classNames(
                      activeTab === 3
                        ? "inline-block !bg-primary-red !text-white active"
                        : "inline-block !text-primary-black !bg-transparent",
                      "px-4 tab-btn text-primary-black hover:text-white lg:w-auto"
                    )}
                  >
                    Kişisel Bilgiler
                  </button>
                </div>
              </div>
              <div>{activeTabMarkup()}</div>

              <div className="max-w-3xl mx-auto">
                <div className="py-3 mx-auto lg:pt-8 space-y-6">
                  <div className="space-y-6">
                    <h4 className="mb-10 text-md">İzinler</h4>
                    <div className="form-input-wrapper">
                      <label
                        htmlFor="toggle1"
                        className="flex items-center cursor-pointer toggle"
                      >
                        <div className="relative">
                          <input
                            type="checkbox"
                            id="toggle1"
                            className="sr-only"
                            checked={userData?.hide_profile ? true : false}
                            onChange={(e) => {
                              setUserData({
                                ...userData,
                                hide_profile: e.target.checked ? true : false,
                              });
                            }}
                          />
                          <div className="block h-4 mr-2 rounded-full bg-secondary-titles w-7"></div>
                          <div className="dot absolute left-0.5 top-0.5 bg-white w-3 h-3 rounded-full transition"></div>
                        </div>
                        <div className="form-label text-body-s text-secondary-titles">
                          Bilgilerim sadece arkadaşlarıma görünür olsun.
                        </div>
                      </label>
                    </div>
                    <div className="form-input-wrapper">
                      {/* <label
                        htmlFor="toggle2"
                        className="flex items-center cursor-pointer toggle"
                      >
                        <div className="relative">
                          <input
                            type="checkbox"
                            id="toggle2"
                            className="sr-only"
                            checked={
                              userData?.isFriendsCanSeeAlbums ? true : false
                            }
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                isFriendsCanSeeAlbums: e.target.checked
                                  ? true
                                  : false,
                              })
                            }
                          />
                          <div className="block h-4 mr-2 rounded-full bg-secondary-titles w-7"></div>
                          <div className="dot absolute left-0.5 top-0.5 bg-white w-3 h-3 rounded-full transition"></div>
                        </div>
                        <div className="form-label text-body-s text-secondary-titles">
                          {" "}
                          Albümlerim’deki resimlerimi arkadaşlarım görmesin.{" "}
                        </div>
                      </label> */}
                    </div>
                  </div>
                  <div className="grid items-stretch grid-cols-1 gap-6">
                    <div className="p-5 text-center bg-white border border-secondary-lines rounded-xl">
                      <p className="form-label text-body-s text-secondary-titles">
                        <b>Kaleseramik A.Ş.</b> ve <b>Kalekim A.Ş.</b> olarak etkinlik kayıt ve devamı süreçlerinde işlenen kişisel verilerinize ilişkin aydınlatma metnine{" "}
                        <a
                          href={CLARIFICATION_TEXT_URL}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="font-bold underline text-primary-red"
                        >
                          buradan
                        </a>{" "}
                        ulaşabilirsiniz.
                      </p>
                    </div>
                  </div>
                  <div className="grid items-stretch grid-cols-1 gap-6 md:grid-cols-2">
                    <div className="p-5 space-y-4 bg-white border border-secondary-lines rounded-xl">
                    <div className="form-input-wrapper">
                      <input
                        type="checkbox"
                        id="kk-kvkk"
                        name="kk-kvkk"
                        className="mr-1 form-input"
                        checked
                        disabled
                        readOnly
                      />
                      <label
                        htmlFor="kk-kvkk"
                        className="form-label text-body-s text-secondary-titles"
                      >
                        <b>Kalekim</b> için kişisel verilerimin kullanılan birtakım alt yapı/sistem/e-posta/sunucuların yurt dışında olması sebebiyle yurtdışında yer alan tedarikçi/sunuculara aktarmasını kabul ediyorum.
                      </label>
                    </div>
                    <div className="space-y-3">
                      <div className="form-input-wrapper">
                        <input
                          type="checkbox"
                          id="kk-iys"
                          name="kk-iys"
                          className="mr-1 form-input"
                          checked={kkIysPermission}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setKkIysPermission(checked);
                            setUserData({
                              ...userData,
                              kkEmailPermission: checked,
                              kkSMSPermission: checked,
                              kkCallPermission: checked,
                            });
                          }}
                        />
                        <label htmlFor="kk-iys" className="form-label text-body-s text-secondary-titles">
                          <b>Kalekim</b> tarafından tarafıma kampanya, etkinlik ve
                          bilgilendirme içerikli ticari elektronik iletilerin
                          aşağıda seçtiğim kanallar üzerinden gönderilmesini kabul
                          ediyorum.
                        </label>
                      </div>
                      {kkIysPermission && (
                      <div className="flex flex-wrap gap-x-6 gap-y-2">
                        <div className="form-input-wrapper">
                          <input
                            type="checkbox"
                            id="kk-mail"
                            name="kk-mail"
                            className="mr-1 form-input"
                            checked={userData?.kkEmailPermission ? true : false}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                kkEmailPermission: e.target.checked ? true : false,
                              })
                            }
                          />
                          <label htmlFor="kk-mail" className="form-label text-body-s text-secondary-titles">
                            Mail
                          </label>
                        </div>
                        <div className="form-input-wrapper">
                          <input
                            type="checkbox"
                            id="kk-sms"
                            name="kk-sms"
                            className="mr-1 form-input"
                            checked={userData?.kkSMSPermission ? true : false}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                kkSMSPermission: e.target.checked ? true : false,
                              })
                            }
                          />
                          <label htmlFor="kk-sms" className="form-label text-body-s text-secondary-titles">
                            SMS
                          </label>
                        </div>
                        <div className="form-input-wrapper">
                          <input
                            type="checkbox"
                            id="kk-call"
                            name="kk-call"
                            className="mr-1 form-input"
                            checked={userData?.kkCallPermission ? true : false}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                kkCallPermission: e.target.checked ? true : false,
                              })
                            }
                          />
                          <label htmlFor="kk-call" className="form-label text-body-s text-secondary-titles">
                            Arama
                          </label>
                        </div>
                      </div>
                      )}
                    </div>
                  </div>
                  <div className={classNames("p-5 space-y-4 bg-white border border-secondary-lines rounded-xl", {
                    hidden: userData?.siteId === "tali",
                  })}>
                    <div className="form-input-wrapper">
                      <input
                        type="checkbox"
                        id="ks-kvkk"
                        name="ks-kvkk"
                        className="mr-1 form-input"
                        checked
                        disabled
                        readOnly
                      />
                      <label
                        htmlFor="ks-kvkk"
                        className="form-label text-body-s text-secondary-titles"
                      >
                        <b>Kaleseramik</b> için kişisel verilerimin kullanılan birtakım alt yapı/sistem/e-posta/sunucuların yurt dışında olması sebebiyle yurtdışında yer alan tedarikçi/sunuculara aktarmasını kabul ediyorum.
                      </label>
                    </div>
                    <div className="space-y-3">
                      <div className="form-input-wrapper">
                        <input
                          type="checkbox"
                          id="ks-iys"
                          name="ks-iys"
                          className="mr-1 form-input"
                          checked={ksIysPermission}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            setKsIysPermission(checked);
                            setUserData({
                              ...userData,
                              ksEmailPermission: checked,
                              ksSMSPermission: checked,
                              ksCallPermission: checked,
                            });
                          }}
                        />
                        <label htmlFor="ks-iys" className="form-label text-body-s text-secondary-titles">
                          <b>Kaleseramik</b> tarafından tarafıma kampanya, etkinlik
                          ve bilgilendirme içerikli ticari elektronik iletilerin
                          aşağıda seçtiğim kanallar üzerinden gönderilmesini kabul
                          ediyorum.
                        </label>
                      </div>
                      {ksIysPermission && (
                      <div className="flex flex-wrap gap-x-6 gap-y-2">
                        <div className="form-input-wrapper">
                          <input
                            type="checkbox"
                            id="ks-mail"
                            name="ks-mail"
                            className="mr-1 form-input"
                            checked={userData?.ksEmailPermission ? true : false}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                ksEmailPermission: e.target.checked ? true : false,
                              })
                            }
                          />
                          <label htmlFor="ks-mail" className="form-label text-body-s text-secondary-titles">
                            Mail
                          </label>
                        </div>
                        <div className="form-input-wrapper">
                          <input
                            type="checkbox"
                            id="ks-sms"
                            name="ks-sms"
                            className="mr-1 form-input"
                            checked={userData?.ksSMSPermission ? true : false}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                ksSMSPermission: e.target.checked ? true : false,
                              })
                            }
                          />
                          <label htmlFor="ks-sms" className="form-label text-body-s text-secondary-titles">
                            SMS
                          </label>
                        </div>
                        <div className="form-input-wrapper">
                          <input
                            type="checkbox"
                            id="ks-call"
                            name="ks-call"
                            className="mr-1 form-input"
                            checked={userData?.ksCallPermission ? true : false}
                            onChange={(e) =>
                              setUserData({
                                ...userData,
                                ksCallPermission: e.target.checked ? true : false,
                              })
                            }
                          />
                          <label htmlFor="ks-call" className="form-label text-body-s text-secondary-titles">
                            Arama
                          </label>
                        </div>
                      </div>
                      )}
                    </div>
                  </div>
                  </div>
                </div>
                <div className="px-4 lg:px-0 w-full lg:max-w-[12rem] items-center flex mx-auto mt-16">
                  <button
                    type="submit"
                    className="w-full max-w-full uppercase form-submit-btn"
                  >
                    KAYDET
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </AuthLayout>
  );
}
